import * as React from 'react';
import { SVGProps } from 'react';
const FilterRemove = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		viewBox="0 0 122.88 110.668"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M91.124 15.645c12.928 0 23.406 10.479 23.406 23.406s-10.479 23.406-23.406 23.406-23.406-10.479-23.406-23.406c0-12.926 10.479-23.406 23.406-23.406zM2.756 0h117.322a2.801 2.801 0 0 1 2.802 2.802 2.75 2.75 0 0 1-.996 2.139l-10.667 13.556a28.777 28.777 0 0 0-4.614-3.672l6.628-9.22H9.43l37.975 46.171c.59.516.958 1.254.958 2.102v49.148l21.056-9.623V57.896a28.914 28.914 0 0 0 5.642 4.996v32.133a2.735 2.735 0 0 1-1.586 2.506l-26.476 12.758a2.753 2.753 0 0 1-3.798-1.033 2.74 2.74 0 0 1-.368-1.4V55.02L.803 4.756a2.825 2.825 0 0 1 0-3.945A2.731 2.731 0 0 1 2.756 0zM96.93 28.282a3.388 3.388 0 0 1 4.825-.013 3.47 3.47 0 0 1 .013 4.872l-5.829 5.914 5.836 5.919c1.317 1.338 1.299 3.506-.04 4.843-1.34 1.336-3.493 1.333-4.81-.006l-5.797-5.878-5.807 5.889a3.39 3.39 0 0 1-4.826.013 3.47 3.47 0 0 1-.013-4.872l5.83-5.913-5.836-5.919c-1.317-1.338-1.3-3.507.04-4.843a3.385 3.385 0 0 1 4.81.006l5.796 5.878 5.808-5.89z"
			clipRule="evenodd"
		/>
	</svg>
);
export default FilterRemove;
